const UNREAD_MESSAGES_BY_RECEIVER = `
  query UnreadMessagesByReceiver($receiverID: String!, $filter: ModelMessagesFilterInput, $limit: Int, $nextToken: String) {
    messagesByReceiverID(receiverID: $receiverID, sortDirection: DESC, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { id }
      nextToken
    }
  }
`;

const PAGE_SIZE = 200;
const MAX_PAGES = 5;

export const hasUnreadMessages = async (client, userID) => {
  if (!userID) return false;
  let nextToken = null;
  let pages = 0;
  do {
    const result = await client.graphql({
      query: UNREAD_MESSAGES_BY_RECEIVER,
      variables: {
        receiverID: userID,
        filter: {
          readStatus: { eq: false },
          receiverDeleted: { ne: true },
        },
        limit: PAGE_SIZE,
        ...(nextToken && { nextToken }),
      },
      authMode: 'userPool',
    });
    const page = result?.data?.messagesByReceiverID;
    if (page?.items?.length > 0) return true;
    nextToken = page?.nextToken;
    pages++;
  } while (nextToken && pages < MAX_PAGES);
  return false;
};
